import { render, staticRenderFns } from "./VehicleEditor.vue?vue&type=template&id=0ad4531b&scoped=true"
import script from "./VehicleEditor.vue?vue&type=script&lang=js"
export * from "./VehicleEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad4531b",
  null
  
)

export default component.exports